import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";
import { ClearSelection } from "./ClearSelection.jsx";

export const SelectTagWithAddNew = ({
  id = "",
  value = "",
  onChange = (e) => {},
  multiple = false,
  allTags,
}) => {
  const [activeTag, setTag] = useState("");
  const [allTagsList, setAllTags] = useState([]);
  useEffect(() => {
    setAllTags(allTags);
  }, [allTags]);

  const selectValue = multiple
    ? (value ? value.split(",").map((v) => v.trim()).filter(Boolean) : [])
    : value;

  const handleChange = (val) => {
    if (multiple) {
      onChange(Array.isArray(val) ? val.join(",") : "");
    } else {
      onChange(val);
    }
  };

  return (
    <div className="row" style={{gap: 6}}>
      <Select
        mode={multiple ? "multiple" : undefined}
        value={selectValue}
        onChange={handleChange}
        dropdownRender={(menu) => (
          <div>
            {menu}
            <Divider style={{ margin: "4px 0" }} />
            <div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
              <Input
                style={{ flex: "auto" }}
                value={activeTag}
                onChange={(event) =>
                  setTag(
                    event.target.value.replace(/^\w/, (c) => c.toUpperCase())
                  )
                }
              />
              <Button
                type="primary"
                style={{ marginLeft: 4 }}
                onClick={() => {
                  if (activeTag?.length > 0) {
                    setAllTags(allTagsList.concat(activeTag));
                    setTag("");
                  }
                }}
              >
                <PlusOutlined /> {$t("Voeg toe")}
              </Button>
            </div>
          </div>
        )}
      >
        {allTagsList?.map(
          (tag, key) =>
            tag && (
              <Select.Option key={key} value={tag}>
                {tag}
              </Select.Option>
            )
        )}
      </Select>

      <ClearSelection onClick={() => {
        setTag("");
        onChange("");
      }} />
    </div>
  );
};
